// Simple session-based auth check. Tab close = logged out.
const AUTH_KEY = 'jh_auth';
const PASSWORD = process.env.REACT_APP_PASSWORD; 

export const login = (password) => {
  if (password === PASSWORD) {
    sessionStorage.setItem(AUTH_KEY, 'true');
    return true;
  }
  return false;
};

export const isAuthenticated = () => sessionStorage.getItem(AUTH_KEY) === 'true';

export const logout = () => sessionStorage.removeItem(AUTH_KEY);